import { initializeApp, getApps } from "firebase/app";

import { GoogleAuthProvider, getAuth } from "firebase/auth";

export class FirebaseApp {
  static firebaseApp = undefined;
  static auth = undefined;
  static db = undefined;
  static firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);
  static googleProvider = undefined;

  static init() {
    this.firebaseApp = initializeApp(this.firebaseConfig);
    this.auth = getAuth(this.firebaseApp);
    this.googleProvider = new GoogleAuthProvider(this.firebaseApp);
    this.googleProvider.setCustomParameters({
      prompt: "select_account",
    });
    //this.db = getFirestore(this.firebaseApp);
  }

  static isFirebaseAppInitialized() {
    try {
      return getApps().length > 0;
    } catch (err) {
      alert(err);
    }
  }
}
